import HttpService from './http-service';
import EdudoResponse from '../models/edudo-response';

export default class ActivityService {
  private schoolUuid: string;

  constructor(schoolUuid: string) {
    this.schoolUuid = schoolUuid;
  }

  private basePath(): string {
    return `/v1/schools/${this.schoolUuid}/activities`;
  }

  private backofficeBasePath(): string {
    return `/school-backoffice-bff/v1/schools/${this.schoolUuid}/activities`;
  }

  async listBackoffice(
    limit: number = 20,
    offset: number = 0
  ): Promise<BackofficeActivityListItemDto[]> {
    const response = await HttpService.getJson<
      EdudoResponse<BackofficeActivityListItemDto[]>
    >(`${this.backofficeBasePath()}?limit=${limit}&offset=${offset}`);

    return response.data;
  }

  // A tela de listagem não pagina: percorre as páginas até a última (o BFF
  // aceita no máximo 100 por página).
  async listAllBackoffice(): Promise<BackofficeActivityListItemDto[]> {
    const pageSize = 100;
    const all: BackofficeActivityListItemDto[] = [];

    for (let offset = 0; ; offset += pageSize) {
      const page = await this.listBackoffice(pageSize, offset);
      all.push(...page);
      if (page.length < pageSize) return all;
    }
  }

  async getBackoffice(activityId: string): Promise<BackofficeActivityDetailDto> {
    const response = await HttpService.getJson<EdudoResponse<BackofficeActivityDetailDto>>(
      `${this.backofficeBasePath()}/${activityId}`
    );

    return response.data;
  }

  // Rota canônica: devolve os uuids crus (files/recipients) no formato que o PUT
  // espera de volta. É a que o formulário de edição usa, e não a do BFF.
  async getActivity(activityId: string): Promise<ActivityDto> {
    const response = await HttpService.getJson<EdudoResponse<ActivityDto>>(
      `${this.basePath()}/${activityId}`
    );

    return response.data;
  }

  async createActivity(data: ActivityRequest): Promise<ActivityDto> {
    const response = await HttpService.postJson<EdudoResponse<ActivityDto>>(
      this.basePath(),
      data
    );

    return response.data;
  }

  async updateActivity(activityId: string, data: ActivityRequest): Promise<ActivityDto> {
    const response = await HttpService.putJson<EdudoResponse<ActivityDto>>(
      `${this.basePath()}/${activityId}`,
      data
    );

    return response.data;
  }

  async deleteActivity(activityId: string): Promise<void> {
    await HttpService.delete(`${this.basePath()}/${activityId}`);
  }
}
